const internsData = [
  {
    name: 'Anushka',
    slug: 'anushka',
    photo: '/images/interns/anushka.jpg',
    verificationCode: '8F3K2A91',
    internId: 'AILYT/2026/001',
    role: 'Software Development Intern',
    batch: '2026',
    education: 'Bachelor of Computer Applications (BCA) – Graduate',
    startDate: '01 Jan 2026',
    endDate: '30 June 2026',
    email: 'anushkamaurya070@gmail.com',
    linkedin: '',
    status: 'Verified',
    certificate: 'Valid',

    skills: [
      'HTML',
      'CSS',
      'JavaScript',
      'MySQL',
      'Flutter',
      'Node.js',
      'Express.js',
      'MongoDB',
      'Render',
    ],

    about:
      'A BCA graduate with a strong interest in software and web development. Passionate about learning new technologies, solving real-world problems, and building user-friendly applications. A quick learner with good communication and teamwork skills.',

    projects: [
      {
        title: 'The Real Health (TRH) App',
        description:
          'A healthcare application designed to connect users, doctors, and administrators. It includes OTP login, registration, health questionnaires, appointment booking, doctor availability, consultation notes, and appointment management. Contributed to frontend development, UI improvements, testing, and integration support.',
      },
      {
        title: 'CRM Application',
        description:
          'A customer relationship management system developed to manage customers, employees, students, sales, notifications, and daily business activities. It includes role-based dashboards for admin, employees, customers, and students. Contributed to UI development, dashboard modules, database-related tasks, and feature testing.',
      },
    ],
  },

  {
    name: 'Gunjan Verma',
    slug: 'gunjan-verma',
    photo: '/images/interns/gunjan-verma.jpg',
    verificationCode: '7D9M4Q28',
    internId: 'AILYT/2026/002',
    role: 'Software Development Intern',
    batch: '2026',
    education: 'Bachelor of Computer Applications (BCA) – Graduate',
    startDate: '01 Jan 2026',
    endDate: '30 June 2026',
    email: 'gunjanverma7070@gmail.com',
    linkedin: '',
    status: 'Verified',
    certificate: 'Valid',

    skills: [
      'HTML',
      'CSS',
      'JavaScript',
      'MySQL',
      'Flutter',
      'Node.js',
      'Express.js',
      'MongoDB',
      'Render',
    ],

    about:
      'A BCA graduate with a strong interest in software and web development. Passionate about learning new technologies, solving real-world problems, and building user-friendly applications. A quick learner with good communication and teamwork skills.',

    projects: [
      {
        title: 'The Real Health (TRH) App',
        description:
          'A healthcare application designed to connect users, doctors, and administrators. It includes OTP login, registration, health questionnaires, appointment booking, doctor availability, consultation notes, and appointment management. Contributed to frontend development, UI improvements, testing, and integration support.',
      },
      {
        title: 'CRM Application',
        description:
          'A customer relationship management system developed to manage customers, employees, students, sales, notifications, and daily business activities. It includes role-based dashboards for admin, employees, customers, and students. Contributed to UI development, dashboard modules, database-related tasks, and feature testing.',
      },
    ],
  },

  {
    name: 'Kajal Rajput',
    slug: 'kajal-rajput',
    photo: '/images/interns/kajal-rajput.jpg',
    verificationCode: '5R8T1L63',
    internId: 'AILYT/2026/003',
    role: 'Software Development Intern',
    batch: '2026',
    education: 'Bachelor of Computer Applications (BCA) – Graduate',
    startDate: '01 Feb 2026',
    endDate: '31 July 2026',
    email: 'kajalrajput4624@gmail.com',
    linkedin: 'https://www.linkedin.com/in/kajal-rajput-4a7887313?utm_source=share_via&utm_content=profile&utm_medium=member_android',
    status: 'Verified',
    certificate: 'Valid',

    skills: [
      'HTML',
      'CSS',
      'JavaScript',
      'MySQL',
      'Flutter',
      'Node.js',
      'Express.js',
      'MongoDB',
      'Render',
    ],

    about:
      'A BCA graduate with a strong interest in software and web development. Passionate about learning new technologies, solving real-world problems, and building user-friendly applications. A quick learner with good communication and teamwork skills.',

    projects: [
      {
        title: 'The Real Health (TRH) App',
        description:
          'A healthcare application designed to connect users, doctors, and administrators. It includes OTP login, registration, health questionnaires, appointment booking, doctor availability, consultation notes, and appointment management. Contributed to frontend development, UI improvements, testing, and integration support.',
      },
      {
        title: 'CRM Application',
        description:
          'A customer relationship management system developed to manage customers, employees, students, sales, notifications, and daily business activities. It includes role-based dashboards for admin, employees, customers, and students. Contributed to UI development, dashboard modules, database-related tasks, and feature testing.',
      },
    ],
  },

  {
    name: 'Nidhi',
    slug: 'nidhi',
    photo: '/images/interns/nidhi.jpg',
    verificationCode: '2P6X9B47',
    internId: 'AILYT/2026/004',
    role: 'Software Development Intern',
    batch: '2026',
    education: 'Bachelor of Computer Applications (BCA) – Graduate',
    startDate: '01 Jan 2026',
    endDate: '30 June 2026',
    email: 'nidhii6264@gmail.com',
    linkedin:
      'https://www.linkedin.com/in/nidhi-7a72343b5',
    status: 'Verified',
    certificate: 'Valid',

    skills: [
      'Flutter',
      'Dart',
      'Node.js',
      'Express.js',
      'MongoDB',
    ],

    about:
      'A BCA graduate with a strong interest in mobile application and backend development. Passionate about learning new technologies, solving real-world problems, and building reliable applications. A quick learner with good communication and teamwork skills.',

    projects: [
      {
        title: 'TRH (The Real Health) Application',
        description:
          'A healthcare application developed using Flutter, Node.js, Express.js, and MongoDB. It connects users, doctors, and administrators through OTP login, user registration, health questionnaires, appointment booking, doctor availability, consultation management, and role-based dashboards.',
      },
    ],
  },

  {
    name: 'Rakhi',
    slug: 'rakhi',
    photo: '/images/interns/rakhi.jpg',
    verificationCode: '9C4V7N12',
    internId: 'AILYT/2026/005',
    role: 'Software Development Intern',
    batch: '2026',
    education: 'Bachelor of Computer Applications (BCA) – Graduate',
    startDate: '01 Jan 2026',
    endDate: '30 June 2026',
    email: 'rakhi.profilemail@gmail.com',
    linkedin: '',
    status: 'Verified',
    certificate: 'Valid',

    skills: [
      'HTML',
      'CSS',
      'JavaScript',
      'MySQL',
      'Flutter',
      'Node.js',
      'Express.js',
      'MongoDB',
      'Render',
    ],

    about:
      'A BCA graduate with a strong interest in software and web development. Passionate about learning new technologies, solving real-world problems, and building user-friendly applications. A quick learner with good communication and teamwork skills.',

    projects: [
      {
        title: 'The Real Health (TRH) App',
        description:
          'A healthcare application designed to connect users, doctors, and administrators. It includes OTP login, registration, health questionnaires, appointment booking, doctor availability, consultation notes, and appointment management.',
      },
      {
        title: 'CRM Application',
        description:
          'A customer relationship management system developed to manage customers, employees, students, sales, notifications, and daily business activities.',
      },
    ],
  },

  {
    name: 'Ruchi Kothiyal',
    slug: 'ruchi-kothiyal',
    photo: '/images/interns/ruchi-kothiyal.jpg',
    verificationCode: '4H7W2K85',
    internId: 'AILYT/2026/006',
    role: 'Software Development Intern',
    batch: '2026',
    education: 'Bachelor of Information Technology(Bsc.IT) – Graduate',
    startDate: '01 Jan 2026',
    endDate: '30 June 2026',
    email: 'kothiyalruchi18@gmail.com',
    linkedin:
      'https://www.linkedin.com/in/ruchi-kothiyal-b0608941a',
    status: 'Verified',
    certificate: 'Valid',

    skills: [
      'Flutter',
      'Dart',
      'Node.js',
      'Express.js',
      'MongoDB',
    ],

    about:
      'A Bsc.It graduate with a strong interest in mobile application and backend development. Passionate about learning new technologies, solving real-world problems, and building reliable applications. A quick learner with good communication and teamwork skills.',

    projects: [
      {
        title: 'TRH (The Real Health) Application',
        description:
          'A healthcare application developed using Flutter, Node.js, Express.js, and MongoDB. It connects users, doctors, and administrators through OTP login, registration, health questionnaires, appointment booking, doctor availability, consultation management, and role-based dashboards.',
      },
    ],
  },

  {
    name: 'Saloni Ramola',
    slug: 'saloni-ramola',
    photo: '/images/interns/saloni-ramola.jpg',
    verificationCode: '6Y1J8F39',
    internId: 'AILYT/2026/007',
    role: 'Software Development Intern',
    batch: '2026',
    education: 'Bachelor of Information Technology(Bsc.IT) – Graduate',
    startDate: '01 Jan 2026',
    endDate: '30 June 2026',
    email: 'ramolasaloni424@gmail.com',
    linkedin:
      'https://www.linkedin.com/in/saloni-ramola-81001641a',
    status: 'Verified',
    certificate: 'Valid',

    skills: [
      'Flutter',
      'Dart',
      'Node.js',
      'Express.js',
      'MongoDB',
    ],

    about:
      'A Bsc.It graduate with a strong interest in mobile application and backend development. Passionate about learning new technologies, solving real-world problems, and building reliable applications.',

    projects: [
      {
        title: 'TRH (The Real Health) Application',
        description:
          'A healthcare application developed using Flutter, Node.js, Express.js, and MongoDB. It connects users, doctors, and administrators through OTP login, registration, health questionnaires, appointment booking, doctor availability, consultation management, and role-based dashboards.',
      },
    ],
  },

  {
    name: 'Suhani',
    slug: 'suhani',
    photo: '/images/interns/suhani.jpg',
    verificationCode: '3L9Q5D74',
    internId: 'AILYT/2026/008',
    role: 'Software Development Intern',
    batch: '2026',
    education: 'Bachelor of Computer Applications (BCA) – Graduate',
    startDate: '01 Jan 2026',
    endDate: '30 June 2026',
    email: 'suhanikashyap478@gmail.com',
    linkedin: '',
    status: 'Verified',
    certificate: 'Valid',

    skills: [
      'HTML',
      'CSS',
      'JavaScript',
      'MySQL',
      'Flutter',
      'Node.js',
      'Express.js',
      'MongoDB',
      'Render',
    ],

    about:
      'A BCA graduate with a strong interest in software and web development. Passionate about learning new technologies, solving real-world problems, and building user-friendly applications.',

    projects: [
      {
        title: 'The Real Health (TRH) App',
        description:
          'A healthcare application designed to connect users, doctors, and administrators. It includes OTP login, registration, health questionnaires, appointment booking, doctor availability, consultation notes, and appointment management.',
      },
      {
        title: 'CRM Application',
        description:
          'A customer relationship management system developed to manage customers, employees, students, sales, notifications, and daily business activities.',
      },
    ],
  },

  {
    name: 'Vidushi Arora',
    slug: 'vidushi-arora',
    photo: '/images/interns/vidushi-arora.jpg',
    verificationCode: '1B6M8R52',
    internId: 'AILYT/2026/009',
    role: 'Software Development Intern',
    batch: '2026',
    education: 'Bachelor of Computer Applications (BCA) – Graduate',
    startDate: '01 Jan 2026',
    endDate: '30 June 2026',
    email: 'aroravidushi98@gmail.com',
    linkedin: '',
    status: 'Verified',
    certificate: 'Valid',

    skills: [
      'Flutter',
      'Dart',
      'Node.js',
      'Express.js',
      'MongoDB',
    ],

    about:
      'A BCA graduate with a strong interest in mobile application and backend development. Passionate about learning new technologies, solving real-world problems, and building reliable applications.',

    projects: [
      {
        title: 'TRH (The Real Health) Application',
        description:
          'A healthcare application developed using Flutter, Node.js, Express.js, and MongoDB. It connects users, doctors, and administrators through OTP login, registration, health questionnaires, appointment booking, doctor availability, consultation management, and role-based dashboards.',
      },
    ],
  },
];

export default internsData;